var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndoor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "64.399 0.685 530.096 545.852",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m438.33 355.32v46.016h-102.48v-260.99c0-6.2344-3.1211-12.059-8.293-15.523l-89.027-59.488h199.81v45.992c0 24.781 37.328 24.781 37.328 0v-64.664c-0.003906-10.305-8.3594-18.664-18.672-18.664h-279.71c-10.422 0.50391-19.117 7.5469-18.957 18.918v373.08c0 6.2422 3.125 12.074 8.3203 15.539l140.18 93.328c11.434 7.6055 29.02 0.50391 29.02-15.535v-74.668h121.15c10.309 0 18.664-8.3555 18.664-18.664v-64.68c-0.003906-24.527-37.336-24.527-37.336 0zm-139.82 123.16-102.85-68.473v-328.41l102.85 68.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m523.01 214.66h-86.945l34.133-34.145c17.32-17.309-9.082-43.715-26.395-26.395l-65.992 66.012c-7.293 7.293-7.293 19.105 0 26.395l65.992 65.992c17.09 17.074 44.418-8.3828 26.395-26.398l-34.129-34.125h86.934c24.887 0 24.887-37.336 0.007812-37.336z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor);
export default __webpack_public_path__ + "static/media/indoor.822b4e96425a5db184770e971d3958b2.svg";
export { ForwardRef as ReactComponent };